import CustomButton from 'components/Buttons/CustomButton'
import { useEffect, useState } from 'react'
import { AlertCircle } from 'react-feather'
import { useSelector } from 'react-redux'
import { FormGroup, Input, Label, Modal, ModalBody } from 'reactstrap'
import {
  useEditCategoryMutation,
  useEditCategoryPersonalMutation,
  useLazyGetCategoriesPersonalQuery,
  useLazyGetCategoriesQuery,
  usePostCategoryMutation,
  usePostCategoryPersonalMutation,
} from './payableNotesApiSlice'

const ModalCategory = ({ isOpen, toggle, row, isReceivable }) => {
  const [errMsg, setErrMsg] = useState('')
  const [category, setCategory] = useState('')

  const { ownerData, profile } = useSelector((s) => s.dashboard)
  const { type } = useSelector((s) => s.payableNotes)
  const [editCategoryCompany, resultCompany] = useEditCategoryMutation()
  const [editCategoryPersonal, resultPersonal] = useEditCategoryPersonalMutation()
  const [postCategoryCompany, resultReceivableCompany] = usePostCategoryMutation()
  const [postCategoryPersonal, resultReceivablePersonal] = usePostCategoryPersonalMutation()
  const [getCategoriesCompany] = useLazyGetCategoriesQuery()
  const [getCategoriesPersonal] = useLazyGetCategoriesPersonalQuery()

  const editCategory = type === 'personal' ? editCategoryPersonal : editCategoryCompany
  const postCategory = type === 'personal' ? postCategoryPersonal : postCategoryCompany
  const getCategories = type === 'personal' ? getCategoriesPersonal : getCategoriesCompany
  const result = type === 'personal' ? resultPersonal : resultCompany
  const resultReceivable = type === 'personal' ? resultReceivablePersonal : resultReceivableCompany
  const userId = type === 'personal' ? profile?.userId : ownerData?.userId

  const handleSubmit = async () => {
    try {
      let body = {}
      if (row) {
        body = {
          label: category,
          id: row?.id,
        }
      } else {
        body = {
          label: category,
          type: isReceivable ? 'receivable' : 'payable',
        }
      }
      const resp = row
        ? await editCategory(body).unwrap()
        : await postCategory(body).unwrap()
      if (!resp?.data?.error) {
        toggle()
        getCategories({
          type: isReceivable ? 'receivable' : 'payable',
          active: 1,
          userId: userId,
        })
      } else {
        throw resp
      }
    } catch (error) {
      setErrMsg(error?.data?.message ?? error?.message)
    }
  }

  useEffect(() => {
    if (row && isOpen) {
      setCategory(row?.label)
    } else {
      setCategory(null)
    }
  }, [row, isOpen])

  return (
    <Modal
      className="p-4"
      centered
      isOpen={isOpen}
      toggle={() => {
        toggle()
        setErrMsg('')
      }}
      autoFocus={false}
    >
      <ModalBody>
        <h5>Tambah kategori</h5>
        <FormGroup className="mt-3">
          <Label>Nama kategori</Label>
          <Input
            autoFocus={true}
            value={category ?? ''}
            onChange={(e) => {
              setCategory(e.target.value)
              setErrMsg('')
            }}
            placeholder="Cth: Beli pupuk"
          />
        </FormGroup>
        {errMsg && (
          <small className="text-danger">
            <AlertCircle size={15} /> {errMsg}
          </small>
        )}
        <div className="d-flex gap-3 mt-4">
          <CustomButton
            onClick={() => {
              toggle()
              setErrMsg('')
            }}
            disabled={result?.isLoading || resultReceivable?.isLoading}
            color="primary"
            outline
            block
          >
            Batal
          </CustomButton>
          <CustomButton
            disabled={
              !category || result?.isLoading || resultReceivable?.isLoading
            }
            onClick={handleSubmit}
            color="primary"
            block
          >
            Simpan
          </CustomButton>
        </div>
      </ModalBody>
    </Modal>
  )
}

export default ModalCategory
